import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { AccessRequestEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class AccessRequestSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    requestCreated$() {
        return this.socketService.receiveMessageObserver(AccessRequestEvents.ACCESS_REQUESTED);
    }

    requestUpdated$() {
        return this.socketService.receiveMessageObserver(AccessRequestEvents.ACCESS_REQUEST_UPDATED);
    }

    requestCanceled$() {
        return this.socketService.receiveMessageObserver(AccessRequestEvents.ACCESS_REQUEST_CANCELED);
    }

    startedEditing$() {
        return this.socketService.receiveMessageObserver(AccessRequestEvents.GUEST_START_EDIT);
    }

    finishedEditing$() {
        return this.socketService.receiveMessageObserver(AccessRequestEvents.GUEST_FINISH_EDIT);
    }

    leftEditing$() {
        return this.socketService.receiveMessageObserver(AccessRequestEvents.GUEST_LEFT_EDIT);
    }
}
